import { Injectable } from '@angular/core';
import { Contact } from 'src/app/models/contact';
import { ApiClient } from '../api.client';

@Injectable()
export class ContactService {
  private resourceEndpoint = 'contacts';

  constructor(private http: ApiClient) {}

  public get(id: number) {
    return this.http.get<Contact>(`${this.resourceEndpoint}/${id}`);
  }

  public getForCustomer(id: number) {
    return this.http.get<Contact[]>(`${this.resourceEndpoint}/customer/${id}`);
  }

  public create(contact: ContactCreate) {
    return this.http.post<Contact>(`${this.resourceEndpoint}`, contact);
  }

  public update(contact: ContactUpdate) {
    return this.http.put<Contact>(
      `${this.resourceEndpoint}/${contact.id}`,
      contact
    );
  }

  public delete(id: number) {
    return this.http.delete(`${this.resourceEndpoint}/${id}`);
  }

  public search(searchTerm: string) {
    return this.http.get<Contact[]>(
      `${this.resourceEndpoint}/search/${encodeURIComponent(searchTerm)}`
    );
  }
}

type ContactUpdate = Omit<
  Contact,
  | 'contact_methods'
  | 'created_at'
  | 'updated_at'
  | 'deleted_at'
  | 'customer_ids'
  | 'full_name'
>;
type ContactCreate = Omit<
  Contact,
  | 'full_name'
  | 'created_at'
  | 'updated_at'
  | 'deleted_at'
  | 'customer_ids'
  | 'contact_methods'
  | 'id'
> & {
  customer_id: number;
  contact_methods: { type: 'email' | 'phone'; value: string }[];
};
